'use client';

import { useEffect } from 'react';

const INTERCEPT_SYMBOL = Symbol('intercepted');

declare global {
  interface Window {
    [INTERCEPT_SYMBOL]: boolean;
  }
}

export interface FinderWindowInterceptProps {
  urlPrefix: string;
  queryString: Record<string, string>;
}

export function FinderWindowIntercept({ urlPrefix, queryString }: FinderWindowInterceptProps) {
  useEffect(() => {
    return interceptWindowOpen(urlPrefix, queryString);
  }, [urlPrefix, queryString]);

  return null;
}

function interceptWindowOpen(urlPrefix: string, queryString: Record<string, string>) {
  if (!window[INTERCEPT_SYMBOL]) {
    const inner = window.open;

    window.open = (function (open) {
      return function (url, name, features) {
        if (typeof url === 'string' && url.startsWith(urlPrefix)) {
          url = rewriteUrl(url, queryString);
        }

        return open.call(window, url, name, features);
      };
    })(inner);

    window[INTERCEPT_SYMBOL] = true;

    // return a teardown function
    return () => {
      window.open = inner;
      window[INTERCEPT_SYMBOL] = false;
    };
  }

  return () => {
    // no-op as window open is already intercepted
  };
}

function rewriteUrl(url: string, queryString: Record<string, string>) {
  const qs = new URLSearchParams(queryString);

  if (url.includes('?')) {
    return `${url}&${qs.toString()}`;
  } else {
    return `${url}?${qs.toString()}`;
  }
}
